import React, { useState, useEffect } from 'react';

// Вспомогательная функция для форматирования времени
const formatTime = (time) => String(time).padStart(2, '0');

function SubscriptionTimer({ expiresAt }) {
    const [timeLeft, setTimeLeft] = useState(null);

    useEffect(() => {
        if (!expiresAt) {
            setTimeLeft(null);
            return;
        }

        const intervalId = setInterval(() => {
            const now = new Date();
            const expirationDate = new Date(expiresAt);
            const difference = expirationDate - now;

            if (difference <= 0) {
                setTimeLeft('Истекла');
                clearInterval(intervalId);
            } else {
                const days = Math.floor(difference / (1000 * 60 * 60 * 24));
                const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
                const minutes = Math.floor((difference / 1000 / 60) % 60);
                const seconds = Math.floor((difference / 1000) % 60);

                setTimeLeft(`${days}д : ${formatTime(hours)}:${formatTime(minutes)}:${formatTime(seconds)}`);
            }
        }, 1000);

        return () => clearInterval(intervalId);

    }, [expiresAt]);

    if (timeLeft === null) {
        return null; // Ничего не показываем, если нет данных о подписке
    }

    const isExpired = timeLeft === 'Истекла';

    return (
        <div style={{
            textAlign: 'center',
            margin: '0 auto 20px auto',
            padding: '10px 20px',
            maxWidth: '400px',
            borderRadius: '8px',
            backgroundColor: isExpired ? '#5d2b31' : '#1e4d2b',
            color: isExpired ? '#f5b9c1' : '#a7d7b7',
            border: `1px solid ${isExpired ? '#8f343b' : '#2e7d32'}`,
            fontWeight: 'bold',
            fontSize: '16px',
        }}>
            {isExpired ? 'Подписка истекла' : `Осталось времени: ${timeLeft}`}
        </div>
    );
}

export default SubscriptionTimer;
